module.exports = __webpack_public_path__ + "static/img/changhua.bf107fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/changhua.png
// module id = 1187
// module chunks = 1